import { Column } from "../types/types";

// функция для подготовки доски в зависимости от стиля игры
export const prepareBoardForGameStyle = (board: Column[],GameStyle: "orbital" | "adress") => {
    if (GameStyle === "orbital") {
      return board.map((col) => ({
        ...col,
        rooms: col.rooms.map((room) => ({
          ...room,
          isOpen: room.characterId !== null,
        })),
      }));
    }

    // adress
    return board.map((col) => ({
      ...col,
      rooms: col.rooms.map((room) => ({
        ...room,
        lightOn: true,
        isOpen: false,
      })),
    }));
  };